import React from "react";
import Utils from 'Common/Utils';
import { ChartIcon, ColumnChartIcon, CombinedChartIcon, LineChartIcon } from 'assests/GmsIcons';
import { useCallback, useEffect, useRef, useState } from 'react';

type ChartTypesProps = {
    selectedItem: string;
    setSelectedItem: (selectedItem: string) => void;
}

export const ChartTypes = ({ selectedItem, setSelectedItem }: ChartTypesProps) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (e: MouseEvent) => Utils.run_callback_on_click_outside_ref(e, ref, () => setShowMenu(false)),
    []
  );

  useEffect(() => {
    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showMenu, handleClickOutside]);

  const handleChartSelection = (type: string) => {
    setShowMenu(false);
    setTimeout(() => {
      setSelectedItem(type);
    }, 0);
  };

  return (
    <div ref={ref} className="tw-relative tw-bg-white">
      <div 
        onClick={() => setShowMenu(prev => !prev)} 
        className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} hover:tw-bg-[#EBECF0] tw-cursor-pointer tw-p-2 tw-ms-3 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}
      >
        <span><ChartIcon /></span>
      </div>
      {showMenu && (
        <div className="tw-absolute tw-top-full tw-left-0 tw-w-48 tw-mt-2 tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0] tw-z-40">
          <div className="tw-py-1 tw-bg-white" role="menu" aria-orientation="vertical">
            <div 
              onClick={() => handleChartSelection("Line Chart")} 
              className="tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA] tw-cursor-pointer"
            >
              <div className={`tw-flex tw-items-center tw-gap-2 ${selectedItem === "Line Chart" ? "tw-text-[#091CAA]" : "tw-text-black"}`}>
                <span><LineChartIcon selected={selectedItem === "Line Chart"} /></span>
                Line Chart
              </div>
            </div>
            <div 
              onClick={() => handleChartSelection("Column Chart")}
              className="tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA] tw-cursor-pointer"
            >
              <div className={`tw-flex tw-items-center tw-gap-2 ${selectedItem === "Column Chart" ? "tw-text-[#091CAA]" : "tw-text-black"}`}>
                <span><ColumnChartIcon selected={selectedItem === "Column Chart"} /></span>
                Column Chart
              </div>
            </div>
            <div 
              onClick={() => handleChartSelection("Line & Column")}
              className="tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA] tw-cursor-pointer"
            >
              <div className={`tw-flex tw-items-center tw-gap-2 ${selectedItem === "Line & Column" ? "tw-text-[#091CAA]" : "tw-text-black"}`}>
                <span><CombinedChartIcon selected={selectedItem === "Line & Column"} /></span>
                Line & Column
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};